export const langs = [
  { label: "English", value: "en" },
  { label: "Español", value: "es" },
  { label: "Indonesia", value: "id" },
  { label: "한국어", value: "ko" },
  { label: "ภาษาไทย", value: "th" },
  { label: "Deutsch", value: "de" },
  { label: "Français", value: "fr" },
  { label: "日本語", value: "ja" },
  { label: "Português", value: "pt" },
]

export const langMap = {
  en: "ENGLISH",
  ko: "KOREAN",
  th: "THAI",
  id: "BAHASA_INDONESIA",
  es: "SPANISH",
  de: "DEUTSCH",
  fr: "FRENCH",
  ja: "JAPANESE",
  pt: "PORTUGUESE",
  ar: "ARAB",
}
